import { getTripsByDateService } from '../../services/tripsByDateService';

// Drop responses for a date the user has already navigated away from.
let latestRequestId = 0;

export async function getTripsByDate(dispatch, date) {
    const requestId = ++latestRequestId;
    try {
        dispatch({ type: 'REQUEST_TRIPS_BY_DATE' });
        let response = await getTripsByDateService(date);
        if (requestId !== latestRequestId) return;
        if (response.data) {
            dispatch({ type: 'FETCH_TRIPS_BY_DATE_SUCCESS', payload: response.data });
            return response.data;
        }
        dispatch({ type: 'FETCH_TRIPS_BY_DATE_ERROR', error: response.data.errors[0] });
    } catch (error) {
        if (requestId !== latestRequestId) return;
        const message =
            error?.response?.data?.error || error?.response?.data?.message || error.message || 'Something went wrong';
        dispatch({ type: 'FETCH_TRIPS_BY_DATE_ERROR', error: message });
    }
}
